import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { environment } from '../../environments/environment';
import { Global } from '../../global';
import { GrupoAccesoRegistro } from '../models/seguridad/grupo_acceso.model';

@Injectable({
    providedIn: 'root'
})
export class SeguridadService {

    prefix = Global.PREFIX_RECORD;
    private sessionPassword: string | null = null;

    constructor() {}

    getCurrentUser(): any | null {
        const userEncrypt = localStorage.getItem(`${this.prefix}.usuarioActivo`);
        let userStr = null;
        if ( userEncrypt ) {
            userStr = CryptoJS.AES.decrypt(userEncrypt, environment.SECRET_KEY).toString(CryptoJS.enc.Utf8);
            return JSON.parse(userStr);
        }
        return userStr;
    }

    setCurrentUser(user?: any): void {
        if (user) {
            const userEncrypt = CryptoJS.AES.encrypt(JSON.stringify(user), environment.SECRET_KEY).toString();
            const userEncryptCookie = CryptoJS.AES.encrypt(JSON.stringify(user.apodo), environment.SECRET_KEY).toString();
            // Guardar en localStorage
            localStorage.setItem(`${this.prefix}.usuarioActivo`, userEncrypt);
            
            // Establecer la cookie con un tiempo de expiración (7 días)
            const expirationDate = new Date();
            expirationDate.setDate(expirationDate.getDate() + 7);  // 7 días de expiración
            document.cookie = `${this.prefix}.usuarioActivo=${userEncryptCookie}; expires=${expirationDate.toUTCString()}; path=/`;
        } else {
            // Eliminar el usuario de localStorage
            localStorage.removeItem(`${this.prefix}.usuarioActivo`);
            
            // Eliminar la cookie de usuario
            document.cookie = `${this.prefix}.usuarioActivo=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
        }
    }

    setUserRemember( obj?: Record<string, any> | null ) {
        if (obj?.usuario && obj?.recordar) {
            const userRemember = {
                usuario: obj.usuario,
                recordar: true
            };
            const userEncrypt = CryptoJS.AES.encrypt(JSON.stringify(userRemember), environment.SECRET_KEY).toString();
            localStorage.setItem(`${this.prefix}.userRemember`, userEncrypt);
        } else {
            localStorage.removeItem(`${this.prefix}.userRemember`);
        }
    }

    getUserRemember() {
        const userEncrypt = localStorage.getItem(`${this.prefix}.userRemember`);
        let userStr = null;
        if ( userEncrypt ) {
            userStr = CryptoJS.AES.decrypt(userEncrypt, environment.SECRET_KEY).toString(CryptoJS.enc.Utf8);
            const userRemember = JSON.parse(userStr);
            if ( userRemember?.usuario && userRemember?.recordar ) {
                this.setUserRemember(userRemember);
                return {
                    usuario: userRemember.usuario,
                    recordar: true
                };
            }
            this.setUserRemember();
        }
        return userStr;
    }

    clearLegacyPasswordState(): void {
        localStorage.removeItem(`${this.prefix}.pass`);
        document.cookie = `${this.prefix}.pass=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
    }

    setToken( token?: string ): void { 
        if (token) {
            const objEncrypt = CryptoJS.AES.encrypt(token, environment.SECRET_KEY).toString();
            localStorage.setItem(`${this.prefix}.token`, objEncrypt);
        } else {
            // sessionStorage.removeItem(`${this.prefix}.usuarioActivo`);
            localStorage.removeItem(`${this.prefix}.token`);
        }
    }

    getToken() {
        const tokenEncrypt = localStorage.getItem(`${this.prefix}.token`);
        const tokenStr = CryptoJS.AES.decrypt(tokenEncrypt, environment.SECRET_KEY).toString(CryptoJS.enc.Utf8);
        return tokenStr;
    }

    getGrupoAcceso() {
        const userEncrypt = localStorage.getItem(`${this.prefix}.usuarioActivo`);
        let userStr = null;
        if ( userEncrypt ) {
            userStr = CryptoJS.AES.decrypt(userEncrypt, environment.SECRET_KEY).toString(CryptoJS.enc.Utf8);
            return JSON.parse(userStr)?.grupo_acceso;
        }
        return userStr;
    }

    async tipoAcceso( codigoModulo: string, codigoRegistro: string ) {
        const grupo = this.getCurrentUser().grupo_acceso;
        if ( grupo.acceso_total ) { return GrupoAccesoRegistro.ACCESO_TODO }

        const modulo = await this.getModulo( grupo, codigoModulo );
        if ( modulo?.acceso_total ) { return GrupoAccesoRegistro.ACCESO_TODO };
        
        const resp = await this.getRegistro(grupo, codigoModulo, codigoRegistro)
        return resp.acceso;

    }

    async puedeCrear( codigoModulo: string, codigoRegistro: string ) {
        const grupo = this.getCurrentUser().grupo_acceso;
        // verificamos que tenga acceso total
        if ( grupo.acceso_total ) {
            return true;
        }
        // verificamos que tenga acceso total al modulo
        const modulo = await this.getModulo( grupo, codigoModulo );
        if ( modulo?.acceso_total ) {
            return true;
        }
        // verificamos que tenga acceso al registro
        const resp = await this.getRegistro(grupo, codigoModulo, codigoRegistro)
        if ( resp?.crear ) {
            return true
        }

        return false;
    }

    async puedeEditar( codigoModulo: string, codigoRegistro: string ) {
        const grupo = this.getCurrentUser().grupo_acceso;
        if ( grupo.acceso_total ) {
            return true;
        }
        // verificamos que tenga acceso total al modulo
        const modulo = await this.getModulo( grupo, codigoModulo );
        if ( modulo?.acceso_total ) {
            return true;
        }
        const resp = await this.getRegistro(grupo, codigoModulo, codigoRegistro)
        if ( resp?.editar ) {
            return true
        }

        return false;
    }

    async puedeEliminar( codigoModulo: string, codigoRegistro: string ) {
        const grupo = this.getCurrentUser().grupo_acceso;
        if ( grupo.acceso_total ) {
            return true;
        }
        // verificamos que tenga acceso total al modulo
        const modulo = await this.getModulo( grupo, codigoModulo );
        if ( modulo?.acceso_total ) {
            return true;
        }
        const resp = await this.getRegistro(grupo, codigoModulo, codigoRegistro)
        if ( resp?.eliminar ) {
            return true
        }

        return false;
    }

    async puedeAnular( codigoModulo: string, codigoRegistro: string ) {
        const grupo = this.getCurrentUser().grupo_acceso;
        if ( grupo.acceso_total ) {
            return true;
        }
        // verificamos que tenga acceso total al modulo
        const modulo = await this.getModulo( grupo, codigoModulo );
        if ( modulo?.acceso_total ) {
            return true;
        }
        const resp = await this.getRegistro(grupo, codigoModulo, codigoRegistro)
        if ( resp?.anular ) {
            return true
        }

        return false;
    }

    async puedeAprobar( codigoModulo: string, codigoRegistro: string ) {
        const grupo = this.getCurrentUser().grupo_acceso;
        if ( grupo.acceso_total ) {
            return true;
        }
        // verificamos que tenga acceso total al modulo
        const modulo = await this.getModulo( grupo, codigoModulo );
        if ( modulo?.acceso_total ) {
            return true;
        }
        const resp = await this.getRegistro(grupo, codigoModulo, codigoRegistro)
        if ( resp?.aprobar ) {
            return true
        }

        return false;
    }

    async puedeInactivar( codigoModulo: string, codigoRegistro: string ) {
        const grupo = this.getCurrentUser().grupo_acceso;
        if ( grupo.acceso_total ) {
            return true;
        }
        // verificamos que tenga acceso total al modulo
        const modulo = await this.getModulo( grupo, codigoModulo );
        if ( modulo?.acceso_total ) {
            return true;
        }
        const resp = await this.getRegistro(grupo, codigoModulo, codigoRegistro)
        if ( resp?.inactivar ) {
            return true
        }

        return false;
    }

    async puedeRevertirInactivacion( codigoModulo: string, codigoRegistro: string ) {
        const grupo = this.getCurrentUser().grupo_acceso;
        if ( grupo.acceso_total ) {
            return true;
        }
        // verificamos que tenga acceso total al modulo
        const modulo = await this.getModulo( grupo, codigoModulo );
        if ( modulo?.acceso_total ) {
            return true;
        }
        const resp = await this.getRegistro(grupo, codigoModulo, codigoRegistro)
        if ( resp?.revertir_inactivacion ) {
            return true
        }

        return false;
    }

    async puedeRevertirAnulacion( codigoModulo: string, codigoRegistro: string ) {
        const grupo = this.getCurrentUser().grupo_acceso;
        if ( grupo.acceso_total ) {
            return true;
        }
        // verificamos que tenga acceso total al modulo
        const modulo = await this.getModulo( grupo, codigoModulo );
        if ( modulo?.acceso_total ) {
            return true;
        }
        const resp = await this.getRegistro(grupo, codigoModulo, codigoRegistro)
        if ( resp?.revertir_anulacion ) {
            return true
        }

        return false;
    }

    async puedeRevertirAprobacion( codigoModulo: string, codigoRegistro: string ) {
        const grupo = this.getCurrentUser().grupo_acceso;
        if ( grupo.acceso_total ) {
            return true;
        }
        // verificamos que tenga acceso total al modulo
        const modulo = await this.getModulo( grupo, codigoModulo );
        if ( modulo?.acceso_total ) {
            return true;
        }
        const resp = await this.getRegistro(grupo, codigoModulo, codigoRegistro)
        if ( resp?.revertir_aprobacion ) {
            return true
        }

        return false;
    }

    async puedeImportar( codigoModulo: string, codigoRegistro: string ) {
        const grupo = this.getCurrentUser().grupo_acceso;
        if ( grupo.acceso_total ) {
            return true;
        }
        // verificamos que tenga acceso total al modulo
        const modulo = await this.getModulo( grupo, codigoModulo );
        if ( modulo?.acceso_total ) {
            return true;
        }
        const resp = await this.getRegistro(grupo, codigoModulo, codigoRegistro)
        if ( resp?.importar ) {
            return true
        }

        return false;
    }

    async puedeEjecutar( codigoModulo: string, codigoReporte: string ) {
        const grupo = this.getCurrentUser().grupo_acceso;
        if ( grupo.acceso_total ) {
            return true;
        }
        // verificamos que tenga acceso total al modulo
        const modulo = await this.getModulo( grupo, codigoModulo );
        if ( modulo?.acceso_total ) {
            return true;
        }
        const resp = await this.getReporte(grupo, codigoModulo, codigoReporte)
        if ( resp?.activo ) {
            return true
        }

        return false;
    }

    async puedeExportar( codigoModulo: string, codigoRegistro: string ) {
        const grupo = this.getCurrentUser().grupo_acceso;
        if ( grupo.acceso_total ) {
            return true;
        }
        // verificamos que tenga acceso total al modulo
        const modulo = await this.getModulo( grupo, codigoModulo );
        if ( modulo?.acceso_total ) {
            return true;
        }
        const resp = await this.getRegistro(grupo, codigoModulo, codigoRegistro)
        if ( resp?.exportar ) {
            return true
        }

        return false;
    }

    async puedeImprimir( codigoModulo: string, codigoRegistro: string ) {
        const grupo = this.getCurrentUser().grupo_acceso;
        if ( grupo.acceso_total ) {
            return true;
        }
        // verificamos que tenga acceso total al modulo
        const modulo = await this.getModulo( grupo, codigoModulo );
        if ( modulo?.acceso_total ) {
            return true;
        }
        const resp = await this.getRegistro(grupo, codigoModulo, codigoRegistro)
        if ( resp?.imprimir ) {
            return true
        }

        return false;
    }

    async tienePermisoEspecial( codigo: string ) {
        return this.tienePermisoEspecialSync(codigo);
    }

    async puedeVer( codigoModulo: string, codigoRegistro: string ) {
        return this.tieneAccesoRegistroSync(codigoModulo, codigoRegistro, 'ver');
    }

    puedeVerSync(codigoModulo: string, codigoRegistro: string): boolean {
        return this.tieneAccesoRegistroSync(codigoModulo, codigoRegistro, 'ver');
    }

    puedeEditarSync(codigoModulo: string, codigoRegistro: string): boolean {
        return this.tieneAccesoRegistroSync(codigoModulo, codigoRegistro, 'editar');
    }

    tienePermisoEspecialSync(codigo: string): boolean {
        const grupo = this.getCurrentUser()?.grupo_acceso;
        if ( !grupo ) {
            return false;
        }

        if ( grupo.acceso_total ) {
            return true;
        }
        const resp = (grupo.permisos || []).find( ( permiso ) => permiso.codigo === codigo );
        if ( resp?.activo ) {
            return true
        }

        return false;
    }

    esSuperusuario(): boolean {
        return this.normalizeBoolean(this.getCurrentUser()?.superusuario);
    }

    async getModulo( grupo: Record<string, any>, codigoModulo: string ) {
        const modulo = grupo.modulos.find( ( modulo ) => (modulo.codigo === codigoModulo ) );
        return modulo;
    }

    async getRegistro( grupo: Record<string, any>, codigoModulo: string, codigoRegistro: string ) {
        const registro = grupo.registros.find( ( registro ) => (registro.modulo === codigoModulo && registro.codigo === codigoRegistro) );
        return registro;
    }

    async getReporte( grupo: Record<string, any>, codigoModulo: string, codigoReporte: string ) {
        const reporte = grupo.reportes.find( ( reporte ) => (reporte.modulo === codigoModulo && reporte.codigo === codigoReporte) );
        return reporte;
    }

    async getSucursales( grupo: Record<string, any>, codigoModulo: string, codigoRegistro: string ) {
        const sucursales = [];     
        const registro = await this.getRegistro( grupo, codigoModulo, codigoRegistro );
        return sucursales
    }

    private normalizeBoolean(value: unknown): boolean {
        if (typeof value === 'boolean') {
            return value;
        }

        if (typeof value === 'number') {
            return value === 1;
        }

        if (typeof value === 'string') {
            return ['1', 'true', 't', 'si', 'sí', 's', 'yes', 'y'].includes(value.trim().toLowerCase());
        }

        return false;
    }

    private tieneAccesoRegistroSync(
        codigoModulo: string,
        codigoRegistro: string,
        accion: 'ver' | 'crear' | 'editar' | 'eliminar' | 'anular' | 'aprobar' | 'inactivar' | 'revertir_inactivacion' | 'revertir_anulacion' | 'revertir_aprobacion' | 'importar' | 'exportar' | 'imprimir'
    ): boolean {
        const grupo = this.getCurrentUser()?.grupo_acceso;
        if (!grupo) {
            return false;
        }

        if (this.normalizeBoolean(grupo.acceso_total)) {
            return true;
        }

        const modulo = (grupo.modulos || []).find((item: Record<string, unknown>) => item.codigo === codigoModulo);
        if (this.normalizeBoolean(modulo?.activo) && this.normalizeBoolean(modulo?.acceso_total)) {
            return true;
        }

        const registro = (grupo.registros || []).find(
            (item: Record<string, unknown>) => item.modulo === codigoModulo && item.codigo === codigoRegistro,
        );

        return this.normalizeBoolean(registro?.[accion]);
    }

    setPassword(password?: any): void {
        if (password) {
            this.sessionPassword = password;
        } else {
            this.sessionPassword = null;
        }
        this.clearLegacyPasswordState();
    }

    getPassword(): any | null {
        this.clearLegacyPasswordState();
        return this.sessionPassword;
    }

    async getLinkPagoFacilSoliciitudes() : Promise< string > {
        try{
            const usuarioEncrypt = localStorage.getItem(`${this.prefix}.usuarioActivo`);
            const usuarioDesencrypt = CryptoJS.AES.decrypt(usuarioEncrypt, environment.SECRET_KEY).toString(CryptoJS.enc.Utf8);
            const usuario = JSON.parse( usuarioDesencrypt );
            const password = this.getPassword();
            if ( !password ) {
                return '';
            }
            const userEncrypt = CryptoJS.AES.encrypt(usuario.codigo, environment.SECRET_KEY ).toString();
            const passEncrypt = CryptoJS.AES.encrypt(password, environment.SECRET_KEY).toString();
            return `${userEncrypt};${passEncrypt}`
        } catch( error ){
            console.error(`Ocurrio un error al crear el link de PF: ${error}`);
            return '';
        }
        
    }
}
